export const slotTime = 60;
export const cellHeight = (heightTask, calendarData) => {
  let baseHeight = 77;

  if (!heightTask || !calendarData?.[0]?.tasks?.length) return baseHeight;

  const hasAddressSynonym = calendarData[0].tasks.some(task => task.addressSynonym);

  const maxPhoneCount = calendarData[0].tasks.reduce((maxCount, task) => {
    if (task.clientPhones) {
      const phoneCount = task.clientPhones.split(',').length;
      return Math.max(maxCount, phoneCount);
    }
    return maxCount;
  }, 0);

  if (hasAddressSynonym) {
    baseHeight += 17;
  }

  return baseHeight + maxPhoneCount * 17;
};


export const dayTaskWrapperMaxWidth = 240;
export const defaultRowCount = 24;

export const TASKS_CONTAINER = 'tasksContainer';

export const SHOW_NO_MORE_INFO_MODAL = 'showNoMoreInfoModal';

export const changeableTaskStatuses = {
  choice: 'choice',
  edit: 'edit',
};
